module.exports = __webpack_public_path__ + "img/cover2.3dab881b.jpg";